import { createAction, props } from '@ngrx/store';
import { Metricas } from '../metricas.model';

export const cargaMet= createAction(
  '[METRICAS] Carga',
  props<{ metricas: Metricas[] }>()
  );
export const limpiaMet = createAction('[METRICAS] Remueve');
